import React, { useEffect, useState } from 'react';
import DisplayLongDescriptionAndVariantMFRName from "../../../../component/custom/DisplayLongDescriptionAndVariantMFRName"
import AddToCart from "../../../../component/custom/AddToCart"
import ProductCompareSelection from "../../../ProductCompare/ProductCompareSelection";
import NavigateToProductDetail from "../../../../component/custom/NavigateToProductDetail";
import DisplayQtyMinQtyMult from "../../../../component/custom/DisplayQtyMinQtyMult";
import PriceTable from "../../../../component/custom/PriceTable";
import useReduxState from "../../../../hooks/useReduxState";
import AxiosIndicatorRunTimeLoader from "../../../../component/Global/AxiosIndicatorRunTimeLoader";
import { useProductStore } from 'src/hooks/product';
import FadeInOut from "../../../../component/Global/FadeInOut";
import { useCartStore } from 'src/hooks/cart';
import { isNumber } from 'underscore';
import useDebounce from "../../../../hooks/useDebounce";
import System from 'src/helper/system';
import { useProductInventoryPriceStore } from 'src/hooks/productInventoryPrice';
import QuantityPicker from 'src/component/custom/QuantityPicker';
import Constants from 'src/helper/Constants';
import ProductInventoryDisplay from 'src/component/custom/ProductInventoryDisplay';
import ProductRepository from 'src/repository/ProductRepository';
import CustomerPartNumberOptions from 'src/component/custom/CustomerPartNumberOptions';
import liveAuth from 'src/helper/liveAuth';
import Bom from "@system/config/bom";
import { useBOMStore } from 'src/hooks/bom';
import BOMImg from "src/assets/images/addtobom-icon.svg";
import { useSystem } from "src/hooks/system";

const ProductDetailAlternativeTab = (props) => {
    const { productDetail } = props
    const [productList, setProductList] = useDebounce([], 200);
    const [loading, set_loading] = useState(false);
    const [alt_product_API_call] = useReduxState(false, 'alt_product_API_call');
    const [subAltShowProductCount, setSubAltShowProductCount] = useState(5);
    const [{ alternative_product_data, alternative_product_count, model_ProductCompare_data }, { fetch_alternative_product_by_variant_number_list }, { }] = useProductStore();
    const [orderby, setOrderby] = useState('');
    const [orderbyDirection, setOrderbyDirection] = useState('asc');
    const [{ CART_BEFORE_TO_SEND_SERVER }, { }, { }] = useCartStore();
    const [{ }, { get_product_assets }, { }] = useProductStore();
    const [{ }, { get_inventory_by_id, get_pricing_by_id, get_current_price_by_quantity }, { }] = useProductInventoryPriceStore();
    const [{ }, { }, { add_part_to_bom, create_bom, create_params_for_add_part_to_bom }] = useBOMStore();
    const { systemModules: { PDP } } = Constants;
    const [,{ get_quantity_format }] = useSystem();

    const fetchFromServer = async () => {
        let products = new ProductRepository().toObjectWithItemNumber(alternative_product_data)
        await setProductList(products);
        await fetchProductAsset(products)
    };

    const fetchProductAsset = async (products = false) => {
        set_loading(true)
        if (!products) {
            products = productList;
        }

        await get_product_assets(products)
        set_loading(false)
    }

    const getOrderByClass = (columnName) => {
        if (columnName === orderby) {
            return 'sorting sorting_' + orderbyDirection
        }
        return 'sorting'
    };

    const toggleOrderBy = async (columnName) => {
        let d = orderbyDirection;
        if (d === 'desc') {
            d = 'asc';
        } else if (d === 'asc') {
            d = 'desc';
        }
        setOrderbyDirection(d);
        setOrderby(columnName);
    };

    useEffect(() => {
        async function fetchHere() {
            await getAlternativeProductByVariantNumber();
        }
        if (alt_product_API_call !== false) {
            fetchHere()
        }
    }, [orderby, orderbyDirection, alt_product_API_call])

    useEffect(() => {
        async function fetchHere() {
            await fetchFromServer()
        }

        if (alt_product_API_call !== false) {
            fetchHere()
        }
    }, [alternative_product_data]);

    const getAlternativeProductByVariantNumber = async (getNewCount = false) => {
        set_loading(true)
        if (getNewCount === false) {
            getNewCount = subAltShowProductCount;
        }
        await fetch_alternative_product_by_variant_number_list({
            ItemNum: productDetail?.ItemNumber,
            orderBy: ((orderby !== '' ? orderby : 'ManufacturerPartNumber') + ' ' + orderbyDirection),
            top: getNewCount > 5 ? getNewCount : 5,
            skip: 0
        })
        set_loading(false)
    }

    const showProductPrice = (v) => {
        const priceList = get_pricing_by_id({ ItemNumber: v.ItemNumber });
        if (CART_BEFORE_TO_SEND_SERVER[v.ItemNumber] && priceList?.length && CART_BEFORE_TO_SEND_SERVER[v.ItemNumber]?.is_updated_qty) {
            let qty = CART_BEFORE_TO_SEND_SERVER[v.ItemNumber].quantityUpdateToCart;
            let p = Number(parseFloat(get_current_price_by_quantity(priceList, qty, true).marketPrice * qty).toFixed(3));
            if ((isNumber(p) && !isNaN(p)) === false) {
                return false;
            }
            return (
                <div className="price dense-hide mb-2">
                    <strong>
                        {window.mct} {window.mct !== window.mcs && <span>{window.mcs}</span>}:
                    </strong>

                    <div className="pull-right font-bold">
                        {get_quantity_format(p)}
                    </div>
                </div>
            );
        } else {
            return false;
        }
    };

    const checkProductTitleMatch = (product) => {
        if (product) {
            if (product.VendorPartNumber && product.ERPMFRPartNumber) {
                return product.ERPMFRPartNumber == product.VendorPartNumber;
            }
        }
        return false;
    };

    const openAddToBOM = async (e) => {
        if (liveAuth.check()) {
            let _product = { ...e, QtyMin: CART_BEFORE_TO_SEND_SERVER[e.ItemNumber]?.quantityUpdateToCart || e.QtyMin };
            System.popup('AddToBOMPopup', { single_product: _product, addFrom: PDP, single_product_pricing_list: get_pricing_by_id({ ItemNumber: _product.ItemNumber }) })
        } else {
            const guestBomID = localStorage.getItem(System.storageName.GUEST_BOM_ID)
            const params = await create_params_for_add_part_to_bom(e)

            if (guestBomID) {
                const addPart = await add_part_to_bom(params)
                if (addPart?.data) {
                    redirectToBOM(guestBomID);
                }
            } else {
                params.source = Constants.systemModules.BOM
                const newBom = await create_bom(params);
                if (newBom?.data) {
                    redirectToBOM(newBom.data);
                }
            }
        }
    };

    const redirectToBOM = (bomId) => {
        window.location.href = Bom.getBomDetailByIdRouteURL(
            bomId,
            {
                go: System.getParams().go
            }
        )
    };

    return (
        <>
            <div className="tab-pane fade" id="tab2">
                <h3 className="mb-2 mt-0 lh-normal">Subs/Alternatives</h3>
                <div className='d-md-block'>
                    {productList && Object.keys(productList).length === 0 &&
                        <AxiosIndicatorRunTimeLoader />
                    }

                    <div className="product-table product-table-striped products-table-wrapper table-responsive">
                        {productList && Object.keys(productList).length > 0 &&
                            <FadeInOut show={true} duration={500}>
                                <table className="bs5 table table-bordered search-products-table mb-0">
                                    <thead>
                                        <tr>
                                            <th
                                                className={'font-10  text-none ' +
                                                    getOrderByClass('ManufacturerPartNumber')
                                                }
                                                onClick={async () => {
                                                    await toggleOrderBy('ManufacturerPartNumber')
                                                }}><span>PRODUCTS</span></th>
                                            <th className='font-10  text-none'><span>PRICE</span></th>
                                            <th className='font-10 text-none'>
                                                <span>AVAILABILITY</span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Object.keys(productList).map((v, i) => (
                                            <tr key={v}>
                                                <td className="product-th additional-stock-wrapper mobile-block product-data minw-auto minw280">
                                                    <div className="col-12 nopadding product-td minw-auto">
                                                        <div className="bs5 row 0 flex-nowrap">
                                                            <div
                                                                className="col-12 static-position product-info-sect-2 pe-3 tab-product-info">
                                                                <div>
                                                                    <div>
                                                                        <div className="product-name">
                                                                            <div className="grey">
                                                                                <NavigateToProductDetail
                                                                                    data={{ ManufacturerName: productList[v]?.ManufacturerName, ERPMFRPartNumber: productList[v]?.ERPMFRPartNumber, ItemNumber: productList[v]?.ItemNumber, ERPPartNumber: productList[v]?.ERPPartNumber }}>
                                                                                    <strong>{productList[v].ERPMFRPartNumber ? productList[v].ERPMFRPartNumber : ''}</strong>
                                                                                </NavigateToProductDetail>
                                                                            </div>
                                                                        </div>
                                                                        <div className="grey">
                                                                            <a>
                                                                                <span className="grey">
                                                                                    <b>{productList[v].ManufacturerName ? productList[v].ManufacturerName : ''}</b>
                                                                                </span>
                                                                            </a>
                                                                        </div>
                                                                    </div>
                                                                    <DisplayLongDescriptionAndVariantMFRName
                                                                        currentProduct={{ ManufacturerName: productList[v]?.ManufacturerName, ShortDescription: productList[v]?.ShortDescription }} />
                                                                </div>
                                                                <div
                                                                    className={checkProductTitleMatch(productList[v]) ? 'd-none' : ''}>
                                                                    <b>Alternate Part No: </b>
                                                                    <span>{productList[v].VendorPartNumber ? productList[v].VendorPartNumber : ""}</span>
                                                                </div>
                                                                <div className="info-capsule mt-4">
                                                                    <div className="info-capsule-item">
                                                                        <ProductCompareSelection
                                                                            single_product={productList[v]}
                                                                            model_ProductCompare_data={model_ProductCompare_data} />
                                                                    </div>
                                                                    {productList[v].ManufacturerDatasheetURL &&
                                                                        <a rel="nofollow"
                                                                            href={productList[v].ManufacturerDatasheetURL}
                                                                            target="_new" className="info-capsule-item">
                                                                            <img className="img-fluid" alt="Datasheet" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAARCAYAAADUryzEAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEoSURBVHgBnZIxS8NAFMf/KYHgINzSRZCm3yCbY1v8Ck4uVgTnZnPTfgTBRZe4iEO0dHRxctTBLyCJi4OD3qBOwvW99lrS47hc++DPS17e/3cvLwGAgqQsivUzzs5QDoDygdQBnJAQ7hhWrmNSuQogMwwCnhOc6+YDo/5OGpvNDQvg1TgZSZIgz/OOUuqMlNQBBIxxGTBqvXT3n09O+dZngjEsC7OFCbjWJ7DaWkNfAC8vJbVIPGqhc8cFCCtjD7RhoGu8hz5qIsDsT5tDFgsSQiDLMvxuK4SbEW6+Hqb14/ae3GhEcre5UwZB0ONXKLVnabtSSqRpip//P1x+jqaZdVXcia2oyS2H8An67jGZvntPR4p1//FYcA2rBBm6F2+365krkL7NPAEy0HwqftdBcQAAAABJRU5ErkJggg" />
                                                                            <span
                                                                                className="datasheet-label">Datasheet</span>
                                                                        </a>
                                                                    }
                                                                    <div className="info-capsule-item cursor-pointer"
                                                                        onClick={() => { openAddToBOM(productList[v]) }}>
                                                                        <img src={BOMImg} className="img-fluid me-1" alt="BOM" />
                                                                        <span
                                                                            className="datasheet-label">Add To BOM</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td className="price-th minw-auto w320">

                                                    <div className="price-td bs5 row flex-nowrap">
                                                        <div className="col price-table w180">
                                                            <CustomerPartNumberOptions
                                                                single_product={productList[v]}
                                                            />
                                                            <PriceTable
                                                                linesToDisplay={3}
                                                                single_product_inventory={get_inventory_by_id(productList[v].ItemNumber)}
                                                                single_product={productList[v]}
                                                                single_product_pricing_list={get_pricing_by_id({ ItemNumber: productList[v].ItemNumber })}
                                                            />
                                                        </div>
                                                        <div className="col-auto">
                                                            {showProductPrice(productList[v]) !== false &&
                                                                showProductPrice(productList[v])
                                                            }
                                                            <div
                                                                className="text-left small-text light light-text collapse_minmax">
                                                                <DisplayQtyMinQtyMult
                                                                    single_product={productList[v]} />
                                                            </div>

                                                            {productList[v].ERPPartNumber &&
                                                                <>
                                                                    <div className="d-flex add-to-cart w-100">
                                                                        <QuantityPicker
                                                                            single_product={productList[v]}
                                                                            single_product_inventory={get_inventory_by_id(productList[v].ItemNumber)}
                                                                            single_product_pricing_list={get_pricing_by_id({ ItemNumber: productList[v].ItemNumber })}
                                                                        />
                                                                    </div>
                                                                    <div className={'add-to-cart w-100'}>
                                                                        <AddToCart
                                                                            single_product_pricing_list={get_pricing_by_id({ ItemNumber: productList[v].ItemNumber })}
                                                                            single_product_inventory={get_inventory_by_id(productList[v].ItemNumber)}
                                                                            single_product={productList[v]}
                                                                            isFrom="PDP" />
                                                                    </div>
                                                                </>
                                                            }
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <ProductInventoryDisplay single_product={productList[v]} single_product_inventory={get_inventory_by_id(productList[v].ItemNumber)} />
                                                </td>
                                            </tr>
                                        ))
                                        }
                                    </tbody>
                                </table>
                            </FadeInOut>
                        }
                        {Object.keys(productList).length === 0 &&
                            <>
                                <div className="tab-pane fade" id="tab2">
                                    No data Found
                                </div>
                            </>
                        }
                    </div>
                    {(Object.keys(productList).length >= 5 && Object.keys(productList).length !== alternative_product_count) &&
                        <div className='text-right  mt-2'>
                            <a href={void (0)} onClick={async () => {
                                setSubAltShowProductCount(Object.keys(productList).length + 5);
                                await getAlternativeProductByVariantNumber(Object.keys(productList).length + 5);
                            }} className='text-blue2 font-bold'>
                                {loading &&
                                    <AxiosIndicatorRunTimeLoader inline={true} />
                                }
                                {!loading ? 'Show More' : ''}
                            </a>
                        </div>
                    }

                </div>
            </div>
        </>
    );
};

export default ProductDetailAlternativeTab;